<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <DeductionsPlanDetailsForm
      v-if="!isLoading"
      :deductionsPlansSlideDetailsData="deductionsPlansSlideDetailsData"
      v-on:addOrUpdateDeductionsPlansSlidesDetails="
        addDeductionsPlansSlidesDetails
      "
      :submitName="$t('add')"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import DeductionsPlanDetailsForm from "@/components/settings/settingsSalary/deductionsPlans/DeductionsPlanDetailsForm.vue";
import DeductionsPlansSlideDetails from "@/models/settings/settingsSalary/deductionsPlans/DeductionsPlansSlideDetails";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "DeductionsPlanDetailsAdd",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    DeductionsPlanDetailsForm,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      deductionsPlansSlideDetailsData: new DeductionsPlansSlideDetails(),
      deductionsPlansToken: this.$route.params.deductionsPlansToken,
    };
  },
  methods: {
    async addDeductionsPlansSlidesDetails() {
      this.isLoading = true;
      this.deductionsPlansSlideDetailsData.deductionsPlansToken =
        this.deductionsPlansToken;
      try {
        let response =
          await this.deductionsPlansSlideDetailsData.addOrUpdateDeductionsPlansSlidesDetails(
            this.language,
            this.userAuthorizeToken
          );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.$router.push(
            "/deductions-plan-details/" +
              this.deductionsPlansSlideDetailsData.deductionsPlansToken
          );
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {
    this.deductionsPlansSlideDetailsData.deductionsPlansToken =
      this.deductionsPlansToken;
  },
};
</script>

<style scoped lang="scss"></style>
